export const quoteDataActionTypes = {
    UpdateQuote:'UpdateQuote',
    UpdateTab: 'UpdateTab',
    ClearQuote:'ClearQuote',
    UpdateRate: 'UpdateRate',
    UpdateCallMessage: 'UpdateCallMessage',
}
